import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RawGenerateDailyReportResponse } from '../types/report';

export function createReportApi(http: Http) {
  return {
    async generateDaily(date: string): Promise<RawGenerateDailyReportResponse> {
      const res = await http.post<RawGenerateDailyReportResponse>(endpoints.report.daily(date));
      return res.data;
    },

    /**
     * [TODO:report-type] 응답이 `string` raw — heviton 컨벤션(`Raw*Response`) 이탈.
     * 형제 `generateDaily` 는 같은 엔드포인트에서 `RawGenerateDailyReportResponse` 반환.
     * BE 의 userId 변형 실제 응답 확인 후 적절한 Raw 타입으로 교체.
     */
    async generateDailyForUser(date: string, userId: string): Promise<string> {
      const res = await http.post<string>(endpoints.report.daily(date), undefined, {
        params: { userId },
      });
      return res.data;
    },
  };
}
